import React, { FC, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { ArticleType } from '../../models/article.model';
import { APIBASEURL } from '../../common/constant';
import { useCookies } from 'react-cookie';
import { Link } from 'react-router-dom';

interface SinglePostProps {
    posts?: Array<ArticleType>;
}

const SinglePost: FC<SinglePostProps> = (
    { posts }) => {
    let { id } = useParams();
    const [cookies] = useCookies(['lang']);
    const [post, setPost] = useState<ArticleType | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    React.useEffect(() => {
        const loadedPost = posts?.find(onePost => onePost.ID === id) ?? null;
        if (loadedPost) {
            setPost(loadedPost);
            setIsLoading(false);
            return;
        }

        if (!id) {
            setIsLoading(false);
            return;
        }

        const loadPost = async () => {
            try {
                const response = await fetch(`${APIBASEURL()}/api/Blogs/${cookies.lang ?? 'ta'}/${id}`);
                if (!response.ok) {
                    throw new Error(`Failed to load post ${id}: ${response.status}`);
                }

                const data = await response.json() as ArticleType;
                setPost(data);
            }
            catch (error) {
                console.error('Error:', error);
            }
            finally {
                setIsLoading(false);
            }
        };

        loadPost();
    }, [cookies.lang, id, posts]);

    return (
        <>
            <Container className='mt-5 py-4 blog-page' fluid="md" style={{ minHeight: "100vh" }}>
                <Row>
                    <Col className='mt-5'>
                        <div className="mb-3">
                            <Link className="btn btn-outline-primary btn-sm" to="/blog">Back to blog</Link>
                        </div>
                        {
                            isLoading ?
                                <div className="alert alert-info">Loading post...</div> :
                                post ?
                                    <article className="blog-single-card">
                                        <h1 className="mb-4">{post.Title}</h1>
                                        <div dangerouslySetInnerHTML={{ __html: post.Body ?? "" }} />
                                    </article> :
                                    <div className="alert alert-warning">Post not found.</div>
                        }
                    </Col>
                </Row >
            </Container>
        </>
    );
}
export default SinglePost;